import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import ToolPage from '../partials/ToolPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import WroListItem from './WroListItem';
import RemoveWroDialog from './RemoveWroDialog';

import { Text, Panel, Box } from '@bigcommerce/big-design';

import { warehouseReceivingOrdersIndex } from '../../redux/actions/warehouseReceivingOrders';

const PrintWros = ({ payload, loadWros, warehouseReceivingOrders }) => {
  const [showRemoveWroDialog, setShowRemoveWroDialog] = useState(false);
  const [modifyItemId, setModifyItemId] = useState(null);


  useEffect(() => {
    loadWros(payload);
  }, []);

  const description = () => {
    return(
      <> 
        <Text>Print Warehouse Receiving Orders from the Supplier Purchase Orders app.</Text>
        <Text>When a purchase order is received, the received items will appear here, ready for printing. Click the "View and Print" button to select print options. The shared print data shown here is only stored for two weeks before it is automatically deleted.</Text>
        <Text>Click a warehouse receiving order's "Remove" button when you're done with it to remove it from this list.</Text>
      </>
    )
  }

  return(
    <>
      <ToolPage title="Print from WROs" description={description()} helpLink="bigcommerce/print-warehouse-receiving-order-labels/">
        <Panel>
          { warehouseReceivingOrders.status !== 'success' &&
            <LoadingSpinner statusText="Loading Warehouse Receiving Orders" />
          }
          { warehouseReceivingOrders.status === 'success' &&
            <>
              { (warehouseReceivingOrders.warehouseReceivingOrders.length === 0) &&
                <Box
                  backgroundColor="warning10"
                  border="box"
                  borderRadius="normal"
                  padding="medium"
                >
                  <div className="text-center">
                    <Text>No outstanding warehouse receiving order prints. Receive more orders in the Supplier Purchase Orders app to see them listed here.</Text>
                  </div>
                </Box>
              }

              { warehouseReceivingOrders.warehouseReceivingOrders.map(order => 
                <WroListItem 
                  order={order} 
                  setShowRemoveWroDialog={setShowRemoveWroDialog}
                  setModifyItemId={setModifyItemId}
                />
              )}
            </>
          }
        </Panel>
      </ToolPage>

      { showRemoveWroDialog &&
        <RemoveWroDialog
          payload={payload}
          wroId={modifyItemId}
          showRemoveWroDialog={showRemoveWroDialog}
          setShowRemoveWroDialog={setShowRemoveWroDialog}
        />
      }

    </>
  )
}

const mapStateToProps = state => ({
  warehouseReceivingOrders: state.warehouseReceivingOrders,
});

const mapDispatchToProps = (dispatch) => ({
  loadWros: (payload) => dispatch(warehouseReceivingOrdersIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintWros);